import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class ApplicationSourceDataService {
    constructor(private dataProvider: DataService) {
    }

    async GetApplicationSource(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetApplicationSource).toPromise();
    }
  
}